import { StyleSheet } from "react-native";
import CommonStyles from "../../../../Diathrive/src/utils/CommonStyles";

export default StyleSheet.create({
  headerTextContainer: {
    ...CommonStyles.flex_row,
    ...CommonStyles.items_center,
  },
});
